import { useMemo } from "react";
import { SubModuleContainer, TableContainer } from "../styles";
import SubModule from "../SubAccess/SubModule";
import TableModuleAccess from "../ModuleAccess/TableModuleAcces";
import { SubModulePermissionProps } from "../PermissionProps";

export const SubModulePermission = (props: SubModulePermissionProps) => {
  const {
    masterPermissionModule,
    handleTabChange,
    masterPermissionSubModule,
    defaultRoleSettings,
    rowHeader,
    onUserUpdate
  } = props;
  const SubModuleMemo = useMemo(
    () => (
      <SubModuleContainer>
        <SubModule
          permissions={masterPermissionModule}
          onChange={handleTabChange}
        />
      </SubModuleContainer>
    ),
    [masterPermissionModule, handleTabChange]
  );

  const TableContainerMemo = useMemo(
    () => (
      <TableContainer>
        <TableModuleAccess
          subModule={masterPermissionSubModule}
          defaultValues={defaultRoleSettings}
          rowHeader={rowHeader}
          onUserUpdate={onUserUpdate}
        />
      </TableContainer>
    ),
    [masterPermissionSubModule, defaultRoleSettings, rowHeader]
  );
  return (
    <>
      {SubModuleMemo}
      {TableContainerMemo}
    </>
  );
};
